module.exports = __webpack_public_path__ + "img/impostor-silhouete-2.c068cb5f.png";